export default [
  'company',
  'deal',
  'person',
  'project'
]
